<script setup>
const { t } = useI18n();
</script>

<template>
  <div class="blocks-award">
    <!--  Title  -->
    <span class="blocks-award__font blocks-award__font--title hidden-mobile">
      {{ t('header.award.title') }}
    </span>
    <span class="blocks-award__font blocks-award__font--title-mobile">
      <CImage
        class="blocks-award__branch blocks-award__branch--left"
        src="/icons/branch.svg"
        alt="Branch"
        loading="lazy"
      />
      <CImage
        class="blocks-award__branch blocks-award__branch--right"
        src="/icons/branch.svg"
        alt="Branch"
        loading="lazy"
      />
      <span class="hidden-desktop">{{ t('header.award.titleMobile') }}</span>
    </span>

    <!--  Text  -->
    <span class="blocks-award__font blocks-award__font--text hidden-mobile">
      {{ t('header.award.text') }}
    </span>
    <span
      class="blocks-award__font blocks-award__font--text-mobile hidden-desktop"
    >
      {{ t('header.award.textMobile') }}
    </span>
  </div>
</template>
